import { getDefaultCdnBaseUrl } from "@tldraw/editor";
import { useMemo } from "react";
let defaultEditorAssetUrls = {
  fonts: {
    tldraw_mono: 'https://padlet.net/fonts/courierprime/courier_prime_bold-webfont.woff2', // Courier Prime
    tldraw_mono_italic: 'https://padlet.net/fonts/courierprime/courier_prime_bold-webfont.woff2',
    tldraw_mono_bold: 'https://padlet.net/fonts/courierprime/courier_prime_bold-webfont.woff2',
    tldraw_mono_italic_bold: 'https://padlet.net/fonts/courierprime/courier_prime_bold-webfont.woff2',
    tldraw_serif: 'https://padlet.net/fonts/lora/3.006/Lora-SemiBold.woff2', // Lora
    tldraw_serif_italic: 'https://padlet.net/fonts/lora/3.006/Lora-SemiBold.woff2',
    tldraw_serif_bold: 'https://padlet.net/fonts/lora/3.006/Lora-SemiBold.woff2',
    tldraw_serif_italic_bold: 'https://padlet.net/fonts/lora/3.006/Lora-SemiBold.woff2',
    tldraw_sans: 'https://padlet.net/fonts/inter/3.19/Inter-SemiBold.woff2', // Inter
    tldraw_sans_italic: 'https://padlet.net/fonts/inter/3.19/Inter-SemiBold.woff2',
    tldraw_sans_bold: 'https://padlet.net/fonts/inter/3.19/Inter-SemiBold.woff2',
    tldraw_sans_italic_bold: 'https://padlet.net/fonts/inter/3.19/Inter-SemiBold.woff2',
    tldraw_draw: 'https://padlet.net/fonts/shantell-sans/Shantell_Sans-Normal-Medium.woff2', // Shantell Sans
    tldraw_draw_italic: 'https://padlet.net/fonts/shantell-sans/Shantell_Sans-Normal-Medium.woff2',
    tldraw_draw_bold: 'https://padlet.net/fonts/shantell-sans/Shantell_Sans-Normal-Medium.woff2',
    tldraw_draw_italic_bold: 'https://padlet.net/fonts/shantell-sans/Shantell_Sans-Normal-Medium.woff2'
  }
};
function setDefaultEditorAssetUrls(assetUrls) {
  defaultEditorAssetUrls = assetUrls;
}
function useDefaultEditorAssetsWithOverrides(overrides) {
  return useMemo(() => {
    if (!overrides) return defaultEditorAssetUrls;
    return {
      fonts: { ...defaultEditorAssetUrls.fonts, ...overrides?.fonts }
    };
  }, [overrides]);
}
export {
  defaultEditorAssetUrls,
  setDefaultEditorAssetUrls,
  useDefaultEditorAssetsWithOverrides
};
//# sourceMappingURL=assetUrls.mjs.map
